import React, { useEffect, useState, lazy } from "react";
import { useTheme } from "./themes/useTheme";
import { ThemeProvider } from "styled-components";
import WebFont from "webfontloader";
import Login from "./views/Login";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./views/Dashboard";
import Logout from "./views/Logout";
import Users from "./views/Dashboard/Users";
import Setting from "./views/Dashboard/Setting";
import Courses from "./views/Dashboard/Courses";
import SingleCourse from "./views/Dashboard/Courses/SingleCourse";
import Error from "./views/Error";
import MentorVerification from "./views/Dashboard/MentorVerification";
import Curriculum from "./views/Dashboard/Curriculum";
import CurriculumView from "./views/Dashboard/Curriculum/CurriculumView";
import Mentors from "./views/Dashboard/Mentors";
import SingleMentor from "./views/Dashboard/Mentor/SingleMentor";
import EditMentor from "./views/Dashboard/Mentor/EditMentor";
import EditCourse from "./views/Dashboard/Courses/EditCourse";
import Payroll from "./views/Dashboard/Payroll";
import Mentees from "./views/Dashboard/Mentees";
import Students from "./views/Dashboard/Students";
import CourseClass from "./views/Dashboard/CourseClass";
import SingleMentee from "./views/Dashboard/Mentee/SingleMenteee";
import SingleStudent from "./views/Dashboard/Student/SingleStudent";
import Statistics from "./views/Dashboard/Statistics";
import Coupons from "./views/Dashboard/Coupons";
import AdminChat from "./views/Dashboard/AdminChat";
import Chat from "views/Dashboard/Chat/Chat";
import Cart from "views/Dashboard/Mentee/Cart";
import Order from "./views/Dashboard/Mentee/Order";
import Notification from "./views/Dashboard/Notification";
import Report from "views/Dashboard/Report";
import Orders from "views/Dashboard/Orders";
import ViewClass from "views/Dashboard/Class/ViewClass";
import TransferClass from "views/Dashboard/TransferClass";

// const Login = lazy(() => import("./views/Login")); lazy loading example. NOT NEEDED in ADMMIN PANEL
import UpcomingInterestedUsers from "./views/Dashboard/UpcomingInterestedUsers";
import CounsellingSessions from "views/Dashboard/Mentor/CounsellingSessions";
import AdminNotification from "views/AdminNotification";

function App(props) {
  const { theme, themeLoaded, getFonts } = useTheme();
  const [selectedTheme, setSelectedTheme] = useState(theme);

  useEffect(() => {
    setSelectedTheme(theme);
  }, [themeLoaded]);

  useEffect(() => {
    WebFont.load({
      google: {
        families: getFonts(),
      },
    });
  });

  return (
    themeLoaded && (
      <ThemeProvider theme={selectedTheme}>
        <BrowserRouter>
          <Routes>
            <Route index element={<Navigate to="dashboard" />} />
            <Route path="login" element={<Login theme={selectedTheme} />} />
            <Route path="logout" element={<Logout />} />
            <Route
              path="dashboard"
              element={<Dashboard theme={selectedTheme} />}
            >
              <Route index element={<Statistics />} />
              <Route
                path="admin-notifications"
                element={<AdminNotification />}
              />
              <Route path="users" element={<Users />} />
              <Route
                path="mentor-verification"
                element={<MentorVerification />}
              />
              <Route path="settings" element={<Setting />} />
              <Route path="notifications" element={<Notification />} />
              <Route path="courses" element={<Courses />} />
              <Route path="classes" element={<CourseClass />} />
              <Route path="classes/students/:id" element={<ViewClass />} />
              <Route
                path="classes/transfer/:fromClassId/:studentId"
                element={<TransferClass />}
              />
              <Route path="mentors" element={<Mentors />} />
              <Route
                path="upcoming-interests"
                element={<UpcomingInterestedUsers />}
              />
              <Route path="counselling" element={<CounsellingSessions />} />
              <Route path="mentors/:id" element={<SingleMentor />} />
              <Route path="mentors/edit" element={<EditMentor />} />
              <Route path="mentors/edit/:id" element={<EditMentor />} />
              <Route path="curriculum" element={<Curriculum />} />
              <Route path="curriculum/edit" element={<CurriculumView />} />
              <Route path="curriculum/edit/:id" element={<CurriculumView />} />
              <Route path="courses/view/:id" element={<EditCourse />} />
              <Route path="courses/edit" element={<EditCourse />} />
              <Route path="courses/edit/:id" element={<EditCourse />} />
              <Route path="payouts" element={<Payroll />} />
              <Route path="reports" element={<Report />} />
              <Route path="orders" element={<Orders />} />
              <Route path="mentees" element={<Mentees />} />
              <Route path="mentees/cart/:id" element={<Cart />} />
              <Route path="mentees/orders/:id" element={<Order />} />
              <Route
                path="mentees/orders"
                element={<Navigate to="/dashboard/mentees" />}
              />
              <Route path="mentees/:id" element={<SingleMentee />} />
              <Route path="students" element={<Students />} />
              <Route path="students/:id" element={<SingleStudent />} />
              <Route path="coupons" element={<Coupons />} />
              <Route path="chat" element={<AdminChat />} />
              <Route path="chat/mentor" element={<Chat room="mentor" />} />
              <Route path="chat/mentee" element={<Chat room="mentee" />} />
            </Route>
            <Route path="*" element={<Error errorCode={404} />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    )
  );
}

export default App;
